























































































































































































































































import ActionBar from '@/components/action-bar/action-bar.vue';
import ProposalProgress from '@/modules/direct-sales/components/proposal-progress/proposal-progress.vue';
import { DIRECT_SALES_ROUTES } from '@/modules/direct-sales/router';
import { Component, Prop, Vue } from 'vue-property-decorator';
import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import PageLoader from '@/components/page-loader/page-loader.vue';
import { numeralService, stringService, httpService } from '@/services';
import numeral from 'numeral';
import { CONFIG } from '@/config';
import { AxiosError, AxiosResponse } from 'axios';
import moment from 'moment';
import { notificationService } from '../../../../services';
import _ from 'lodash';

@Component({
  components: {
    ProposalProgress,
    ActionBar,
    KendoChart,
    PageLoader
  }
})
export default class DirectSalesProposalsCompletePage extends Vue {
  @Prop({ required: true })
  consumerId: number;

  @Prop({ required: true })
  proposalId: number;

  @Prop({ required: true })
  showProgress: number;

  private changeDealer = false;

  public state: any = {
    consumer: {
      id: 0,
      name: '',
      cnpj: '',
      idSalesChannel: 0,
      units: 0,
      updatedAt: '',
      email: '',
      descriptionSalesChannel: ''
    },
    proposalVehicles: [],
    salesman: {
      name: '',
      phone: '',
      email: ''
    },
    proposal: {}
  };

  public numeral = numeral;

  public moment = moment;

  private openChangeDealer() {
    this.state.salesman.name = this.state.proposal.nameDealer;
    this.state.salesman.phone = this.state.proposal.phoneDealer;
    this.state.salesman.email = this.state.proposal.emailDealer;
    this.changeDealer = true;
  }

  private saveDealer() {
    this.state.proposal.nameDealer = this.state.salesman.name;
    this.state.proposal.phoneDealer = this.state.salesman.phone;
    this.state.proposal.emailDealer = this.state.salesman.email;

    httpService.http
      .put(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/dealer/${this.state.proposal.id}`, this.state.proposal)
      .then((res: AxiosResponse) => {
        notificationService.sendToast({
          status: 1,
          type: 'success',
          message: 'Dados do dealer da proposta salvos com sucesso.'
        });

        this.changeDealer = false;
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  private goToDirectSalesHome() {
    this.$router.push({
      name: DIRECT_SALES_ROUTES.PROPOSALS
    });
  }

  private totalVehicles(itens: any) {
    return _.sumBy(itens, 'totalSelected');
  }

  private priceTotalVehicles(itens: any) {
    return _.sumBy(itens, 'priceTotalDiscount');
  }

  public mounted() {
    this.getConsumer();
    this.getProposta();
  }

  private getConsumer() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/consumer/${this.consumerId}`)
      .then((res: AxiosResponse) => {
        this.state.consumer = {
          id: res.data.id,
          name: res.data.name,
          cnpj: res.data.cpfCnpj,
          idSalesChannel: res.data.idSalesChannel,
          units: res.data.qtdPurchase,
          updatedAt: res.data.lastPurchase ? moment(res.data.lastPurchase).format('DD/MM/YYYY') : '',
          email: res.data.email,
          descriptionSalesChannel: res.data.descriptionSalesChannel
        };
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  private getProposta() {
    httpService.http
      .get(`${CONFIG.URL.NEODASH_API}/api/directsales/proposal/${this.proposalId}/getProposal`)
      .then((res: AxiosResponse) => {
        this.state.proposal = res.data;

        this.state.proposalVehicles = _(res.data.proposalVehicles)
          .groupBy(function(f) {
            return f.idColorVehicle + f.idModelVehicle + f.price + f.percentageDiscountPractice + f.daysForBilling;
          })
          .map((m: any) => ({
            familyName: m[0].family,
            modelName: m[0].model,
            color: m[0].color,
            daysForBilling: m[0].daysForBilling,
            priceVehicle: parseFloat(m[0].price),
            priceDiscount: this.getPercentTotalPrice(m[0]),
            priceTotalDiscount:
              this.getPercentTotalPrice(m[0]) *
              _(m)
                .map((m: any) => m.amount)
                .sum(),
            totalSelected: _(m)
              .map((m: any) => m.amount)
              .sum()
          }))
          .orderBy((p: any) => p.modelName)
          .orderBy((p: any) => p.familyName)
          .value();
      })
      .catch((err: AxiosError) => console.log(err.message));
  }

  private getPercentTotalPrice(item) {
    return item.price - (parseFloat(item.price) * parseFloat(item.percentageDiscountPractice)) / 100;
  }

  private formatarCampoCpfCnpj(cpf_cnpj) {
    if (cpf_cnpj) {
      cpf_cnpj = cpf_cnpj.replace(/(\.|\/|\-)/g, '');
      if (cpf_cnpj.length <= 11) {
        cpf_cnpj = this.mascaraCpf(cpf_cnpj);
      } else {
        cpf_cnpj = this.mascaraCnpj(cpf_cnpj);
      }
    }
    return cpf_cnpj;
  }

  private mascaraCpf(valor: string) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }

  private mascaraCnpj(valor: string) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
  }

  /**
   * GeneratePDF
   */
  public generatePDF() {
    const nameArquivo =
      'Proposta_Comercial_VD' +
      this.state.proposalIdFormated +
      '_' +
      moment(new Date()).format('YYYY_MM_DD-hh_mm_ss') +
      '.pdf';
    const draw = kendo.drawing;
    draw
      .drawDOM($('#idcontent'), {
        paperSize: 'A4'
        //landscape: false
      })
      .then(function(root) {
        return draw.exportPDF(root, { paperSize: 'A4' });
      })
      .done(function(data) {
        kendo.saveAs({
          dataURI: data,
          fileName: nameArquivo
        });
      });
  }
}
